import { render, staticRenderFns } from "./apiTest.vue?vue&type=template&id=2c39cb79&scoped=true&"
import script from "./apiTest.vue?vue&type=script&lang=js&"
export * from "./apiTest.vue?vue&type=script&lang=js&"
import style0 from "./apiTest.vue?vue&type=style&index=0&id=2c39cb79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39cb79",
  null
  
)

export default component.exports